import { Box, Container, Typography, Button, Stack, alpha, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import DiamondIcon from '@mui/icons-material/Diamond';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const CTASection = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        position: 'relative',
        background: 'linear-gradient(135deg, #0a0a2a 0%, #0d0d35 50%, #060620 100%)',
        borderTop: '1px solid rgba(212, 175, 55, 0.2)',
        borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 50% 50%, rgba(212, 175, 55, 0.08) 0%, transparent 70%)',
          pointerEvents: 'none',
        },
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={3} alignItems="center" textAlign="center">
          {/* Premium Badge */}
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              px: 2,
              py: 0.5,
              borderRadius: 4,
              background: alpha('#D4AF37', 0.12),
              border: '1px solid rgba(212, 175, 55, 0.25)',
              backdropFilter: 'blur(5px)',
            }}
          >
            <DiamondIcon sx={{ fontSize: 12, color: '#D4AF37' }} />
            <Typography
              sx={{
                color: '#D4AF37',
                fontWeight: 600,
                letterSpacing: 2,
                fontSize: '0.65rem',
                textTransform: 'uppercase',
              }}
            >
              PRIVATE WEALTH SOLUTIONS
            </Typography>
            <DiamondIcon sx={{ fontSize: 12, color: '#D4AF37' }} />
          </Box>

          {/* Main Heading */}
          <Typography 
            variant="h2" 
            sx={{ 
              fontWeight: 800, 
              mb: 1,
              background: 'linear-gradient(135deg, #FFFFFF 0%, #D4AF37 50%, #FFD700 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
            }}
          >
            Ready to Invest in Precious Metals?
          </Typography>

          {/* Subtitle */}
          <Typography 
            variant="body1" 
            sx={{ 
              color: alpha('#FFFFFF', 0.8), 
              maxWidth: '600px',
              fontSize: '1rem',
              lineHeight: 1.6,
            }}
          >
            Join the world's leading investors and institutions who trust Pentillion 
            for their precious metals needs. Access institutional-grade liquidity, 
            competitive pricing, and dedicated relationship management.
          </Typography>

          {/* CTA Buttons */}
          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={3} 
            justifyContent="center"
            sx={{ mt: 2 }}
          >
            <Button
              component={Link}
              to="/contact"
              variant="contained"
              size="large"
              endIcon={<ArrowForwardIcon />}
              sx={{
                background: 'linear-gradient(135deg, #D4AF37 0%, #B8960C 100%)',
                color: '#0a0a2a',
                fontWeight: 700,
                fontSize: '0.9rem',
                px: 5,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                boxShadow: '0 4px 20px rgba(212, 175, 55, 0.3)',
                '&:hover': { 
                  background: 'linear-gradient(135deg, #E5C158 0%, #D4AF37 100%)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 25px rgba(212, 175, 55, 0.4)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              Contact Our Team
            </Button>

            <Button
              component={Link}
              to="/market-data"
              variant="outlined"
              size="large"
              sx={{
                borderColor: '#D4AF37',
                color: '#D4AF37',
                fontWeight: 600,
                fontSize: '0.9rem',
                px: 5,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                '&:hover': { 
                  borderColor: '#FFD700',
                  bgcolor: alpha('#D4AF37', 0.08),
                  color: '#FFD700',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 15px rgba(212, 175, 55, 0.15)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              View Live Prices
            </Button>
          </Stack>

          {/* Trust Indicators */}
          <Stack 
            direction="row" 
            spacing={3} 
            justifyContent="center" 
            sx={{ 
              mt: 4, 
              pt: 3,
              borderTop: '1px solid rgba(212, 175, 55, 0.15)',
              flexWrap: 'wrap',
              gap: 2,
            }}
          >
            {[
              { text: "LBMA Accredited" },
              { text: "24/7 Client Support" },
              { text: "Secure Logistics" },
              { text: "Real-time Pricing" },
            ].map((item, idx) => (
              <Chip
                key={idx}
                label={item.text}
                size="small"
                sx={{
                  bgcolor: alpha('#D4AF37', 0.08),
                  color: '#D4AF37',
                  fontSize: '0.65rem',
                  height: 26,
                  fontWeight: 500,
                  '& .MuiChip-label': { px: 1.5 },
                }}
              />
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default CTASection;